import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizationPipe } from '@abp/ng.core';
import { CXTimePipe } from 'src/core/pipes/cx-time.pipe';
import { ImportStatus } from '../../models';
import { DisplayDateTimePipe } from 'src/core/pipes/display-date-time.pipe';
@Component({
  selector: 'app-import-info-card',
  standalone: true,
  imports: [CommonModule, LocalizationPipe, CXTimePipe, DisplayDateTimePipe],
  templateUrl: './import-info-card.component.html',
  styleUrls: ['./import-info-card.component.scss'],
})
export class ImportInfoCardComponent {
  @Input() timeRemaining: number | null = null;
  @Input() status: ImportStatus = ImportStatus.NotStarted;
  @Input() errorCount: number = 0;
  @Input() systemStartDate: Date | null = null;
  @Input() lastImport: Date | null = null;
  @Output() errorClick = new EventEmitter<void>();

  onErrorClick(): void {
    if (this.errorCount > 0) {
      this.errorClick.emit();
    }
  }

  get hasErrors(): boolean {
    return this.errorCount > 0;
  }
  get isCalculatingTimeRemaining(): boolean {
    return (
      this.timeRemaining == null &&
      (this.status === ImportStatus.Importing || this.status === ImportStatus.Pending)
    );
  }
}
